export class ApiError implements Error {
  name: string;
  message: string;
  response: { data: { code: string } };

  constructor(code: string, message?: string) {
    this.name = "ApiError";
    this.message = message ?? "Toqio Custom API Error";
    this.response = {
      data: { code }
    };
  }
}